/* 石國商店EC｜商品一覧の絞り込み（まとめボタンの動き） */
(function () {
  if (window.__sfFilters) return;
  window.__sfFilters = true;
  var collapsedOnce = false;
  var STOCK_OFF = 'sf_stock_off';
  function isPhone() { return window.matchMedia('(max-width: 991px)').matches; }
  function form() { return document.getElementById('collectionFiltersForm'); }
  function submit() { var f = form(); if (f) f.dispatchEvent(new Event('change', { bubbles: true })); }
  function setHidden(i, v) { if (!i) return; i.value = v; i.disabled = (v === ''); }
  function stockInput(f) { return f ? f.querySelector('#sfopt-s input') : null; }
  /* 「在庫ありだけ表示」をお客さんが自分で切ったかどうか（このタブの間だけ覚える） */
  function stockOff() { try { return sessionStorage.getItem(STOCK_OFF) === '1'; } catch (e) { return false; } }
  function setStockOff(v) { try { if (v) sessionStorage.setItem(STOCK_OFF, '1'); else sessionStorage.removeItem(STOCK_OFF); } catch (e) {} }
  function clearIn(el) {
    el.querySelectorAll('input').forEach(function (i) {
      if (i.type === 'checkbox') i.checked = false;
      else if (i.type === 'hidden') { i.value = ''; i.disabled = true; }
    });
  }
  /* 時計側の幅・美錠側の幅：両方選んだら両方に合う「管幅-美錠幅」だけをチェック */
  function applyWidth(f) {
    if (!f) return;
    var L = [], B = [];
    f.querySelectorAll('[data-sf-w].is-active').forEach(function (b) { L.push(b.getAttribute('data-sf-w')); });
    f.querySelectorAll('[data-sf-bk].is-active').forEach(function (b) { B.push(b.getAttribute('data-sf-bk')); });
    f.querySelectorAll('input[data-lug]').forEach(function (i) {
      var on = (L.length || B.length) && (!L.length || L.indexOf(i.getAttribute('data-lug')) > -1) && (!B.length || B.indexOf(i.getAttribute('data-bk')) > -1);
      i.checked = !!on;
      if (on) i.disabled = false;
    });
  }
  function closeAfterPick(el, turnedOn) {
    if (!turnedOn || !isPhone()) return;
    var d = el.closest('details.sf-sec');
    if (d) d.removeAttribute('open');
  }
  function onOpenPhone() {
    if (!isPhone()) return;
    if (!collapsedOnce) {
      collapsedOnce = true;
      document.querySelectorAll('details[data-sf-collapse]').forEach(function (d) { d.removeAttribute('open'); });
    }
    var head = document.querySelector('[class~="#collection-grid-header"]') || document.getElementById('CollectionProductGrid');
    if (head) window.scrollTo(0, head.getBoundingClientRect().top + window.pageYOffset - 8);
  }
  document.addEventListener('click', function (e) {
    var trg = e.target.closest('modal-trigger');
    if (trg && document.querySelector(trg.getAttribute('target') + ' .sf')) { onOpenPhone(); return; }
    var wb = e.target.closest('[data-sf-w],[data-sf-bk]');
    if (wb) {
      e.preventDefault();
      if (wb.disabled) return;
      var turnOn = !wb.classList.contains('is-active');
      wb.classList.toggle('is-active');
      applyWidth(form());
      closeAfterPick(wb, turnOn);
      submit();
      return;
    }
    var wr = e.target.closest('[data-sf-wrm]');
    if (wr) {
      e.preventDefault();
      var p = wr.getAttribute('data-sf-wrm').split(':');
      var f0 = form();
      if (f0) {
        var t0 = f0.querySelector(p[0] === 'w' ? '[data-sf-w="' + p[1] + '"]' : '[data-sf-bk="' + p[1] + '"]');
        if (t0) t0.classList.remove('is-active');
        applyWidth(f0);
      }
      submit();
      return;
    }
    var b = e.target.closest('[data-sf-toggle]');
    if (b) {
      e.preventDefault();
      if (b.disabled) return;
      var opt = b.closest('[data-sf-opt]');
      var ins = opt.querySelectorAll('input[type=checkbox]');
      var any = Array.prototype.some.call(ins, function (i) { return i.checked; });
      ins.forEach(function (i) { if (any) i.checked = false; else if (!i.disabled) i.checked = true; });
      closeAfterPick(b, !any);
      submit();
      return;
    }
    var pr = e.target.closest('[data-sf-price]');
    if (pr) {
      e.preventDefault();
      var box = pr.closest('[data-sf-pricebox]');
      var on = pr.classList.contains('is-active');
      setHidden(box.querySelector('[data-sf-gte]'), on ? '' : pr.dataset.gte);
      setHidden(box.querySelector('[data-sf-lte]'), on ? '' : pr.dataset.lte);
      closeAfterPick(pr, !on);
      submit();
      return;
    }
    var r = e.target.closest('[data-sf-remove]');
    if (r) {
      e.preventDefault();
      var rid = r.getAttribute('data-sf-remove');
      if (rid === 'sfopt-s') setStockOff(true);
      var t = document.getElementById(rid);
      if (t) clearIn(t);
      submit();
      return;
    }
    var c = e.target.closest('[data-sf-clear]');
    if (c) {
      e.preventDefault();
      var f = form();
      if (f) {
        clearIn(f);
        /* すべて解除しても「在庫ありだけ表示」は最初の状態（オン）に戻す */
        setStockOff(false);
        var s = stockInput(f);
        if (s) s.checked = true;
      }
      submit();
    }
  }, true);
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || !i.matches) return;
    if (i.matches('#sfopt-s input')) setStockOff(!i.checked);
    if (i.matches('.sf-row input[type=checkbox]')) closeAfterPick(i, i.checked);
  }, true);
  function filterURL(f) {
    var p = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (k.indexOf('filter.') === 0 && v !== '') p.append(k, v); });
    var sort = new URLSearchParams(location.search).get('sort_by');
    if (sort) p.append('sort_by', sort);
    return location.pathname + '?' + p.toString();
  }
  function init() {
    var f = form();
    if (!f) return;
    var q = new URLSearchParams(location.search);
    var s = stockInput(f);
    var wantStock = s && !s.checked && !stockOff() && !q.has('filter.v.availability');
    if (wantStock) s.checked = true;
    /* Dバックルの商品ページから「?sf_bk=16」で来たら、美錠幅16mmで絞り込んだ状態にする */
    var bk = q.get('sf_bk');
    var btn = bk ? f.querySelector('[data-sf-bk="' + bk + '"]') : null;
    if (btn) {
      f.querySelectorAll('[data-sf-w],[data-sf-bk]').forEach(function (x) { x.classList.remove('is-active'); });
      btn.classList.add('is-active');
      applyWidth(f);
      location.replace(filterURL(f));
      return;
    }
    /* 最初は「在庫ありだけ表示」をオンにして一覧を出し直す */
    if (wantStock) {
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('collection-filters-form').then(function () { setTimeout(submit, 0); });
      } else {
        location.replace(filterURL(f));
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();